import { Currency } from "@redotech/money/currencies";
import * as z from "zod";

export const deletePaymentMethod = {
  name: "deletePaymentMethod" as const,
  input: z.object({
    primary: z.boolean(),
    currency: z.enum(Currency).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
